/**
 * sticky-atc.js
 * Barra "Adicionar ao Carrinho" fixa no rodapé mobile — PDPs Shopify
 *
 * Estratégia:
 *  - IntersectionObserver no botão ATC original → mostra/esconde a barra
 *  - MutationObserver no botão original → espelha disabled + texto
 *  - MutationObserver no container de preço → espelha preço ao trocar variante
 *  - Click na barra → delega para originalBtn.click() (reusa product-form.js)
 *
 * Compatibilidade: iOS 12.2+, Chrome 51+, Instagram in-app browser (WKWebView)
 */

(function () {
  'use strict';

  function initStickyAtc(bar) {
    var sectionId = bar.dataset.sectionId;

    var originalBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    var stickyBtn = document.getElementById('sticky-atc-btn-' + sectionId);
    var priceContainer = document.getElementById('price-' + sectionId);

    if (!originalBtn || !stickyBtn) return;

    // 1. IntersectionObserver: mostra a barra quando o botão sai da tela
    var visibilityObserver = new IntersectionObserver(
      function (entries) {
        var isVisible = entries[0].isIntersecting;
        if (isVisible) {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        }
      },
      { threshold: 0 }
    );

    visibilityObserver.observe(originalBtn);

    // 2. Click: delega para o botão original
    stickyBtn.addEventListener('click', function () {
      if (!originalBtn.disabled) {
        originalBtn.click();
      }
    });

    // 3. MutationObserver no botão original: espelha disabled + texto
    var btnObserver = new MutationObserver(function () {
      stickyBtn.disabled = originalBtn.disabled;
      var spanEl = originalBtn.querySelector('span:not(.loading__spinner):not(.spinner)');
      if (spanEl) {
        stickyBtn.textContent = spanEl.textContent.trim();
      }
    });

    btnObserver.observe(originalBtn, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    // 4. MutationObserver no container de preço: espelha ao trocar variante
    if (priceContainer) {
      var priceObserver = new MutationObserver(function () {
        syncPrice(priceContainer, bar);
      });

      priceObserver.observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  function syncPrice(priceContainer, bar) {
    var currentPriceEl = bar.querySelector('.sticky-atc__current-price');
    var comparePriceEl = bar.querySelector('.sticky-atc__compare-price');
    if (!currentPriceEl) return;

    var saleEl = priceContainer.querySelector('.price-item--sale.price-item--last');
    var compareEl = priceContainer.querySelector('s.price-item--regular');
    var regularEl = priceContainer.querySelector('span.price-item--regular');

    if (saleEl && compareEl) {
      var saleText = saleEl.textContent.trim();
      var compareText = compareEl.textContent.trim();
      if (saleText) currentPriceEl.textContent = saleText;
      currentPriceEl.classList.add('sticky-atc__current-price--sale');
      if (comparePriceEl) {
        comparePriceEl.textContent = compareText;
        comparePriceEl.style.display = '';
      }
    } else if (regularEl) {
      var regularText = regularEl.textContent.trim();
      if (regularText) currentPriceEl.textContent = regularText;
      currentPriceEl.classList.remove('sticky-atc__current-price--sale');
      if (comparePriceEl) {
        comparePriceEl.style.display = 'none';
      }
    }
  }

  function init() {
    document.querySelectorAll('.sticky-atc').forEach(function (bar) {
      initStickyAtc(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
